import { Directive, Input, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: 'img[default]'
})

export class ImagePreloadDirective {

  defaultImage: string = 'assets/imgs/user-image-placeholder.png';

  @HostBinding('crossOrigin') cross = 'anonymous';
  @HostBinding('src') @Input() src: string;
  @Input() default: string;
  @HostListener('error') async updateUrl() {
    const self = this;
    try {
      const headers = new Headers();
      headers.append('origin', 'tg4.com.br');
      const resp = await fetch(this.src + ((/\?/).test(this.src) ? '&' : '?') + (new Date()).getTime(), {mode: 'cors', headers: headers});
      const blob = await resp.blob();
      if (blob.type.indexOf('image') < 0) { throw new Error('not an image'); }
      const reader = new FileReader();
      reader.onload = function () {
        self.src = <any>this.result;
      }; // <--- `this.result` contains a base64 data URI
      await reader.readAsDataURL(blob);
    } catch (err) {
      this.src = this.default ? this.default : this.defaultImage;
    }
  }
  @HostListener('load') load() {
    // this.className = ' image-loaded';
  }
}
